export enum ActiveTab {
  All = "All",
  NotSubmitted = "NotSubmitted",
  PartiallySubmitted = "PartiallySubmitted",
  Submitted = "Submitted",
  Approved = "Approved",
  ApprovedConditionally = "ApprovedConditionally",
  Declined = "Declined",
  Canceled = "Canceled",
  OnHold = "OnHold"
}
export const newOrder = [
  "criteria",
  "applicants",
  "property",
  "property_group",
  "unit",
  "started_at",
  "submitted_at",
  "updated_at",
  "assigned_to",
  "status"
];
